import { render, staticRenderFns } from "./ExibirOcorrencia.vue?vue&type=template&id=11f7db02&scoped=true&"
import script from "./ExibirOcorrencia.vue?vue&type=script&lang=js&"
export * from "./ExibirOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./ExibirOcorrencia.vue?vue&type=style&index=0&id=11f7db02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7db02",
  null
  
)

export default component.exports